var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return Object.keys(_vm.currentPlanHash).length > 0
    ? _c("div", { staticClass: "current-plans-wrapper" }, [
        _c("div", { staticClass: "current-plans-wrapper-title" }, [
          _vm._v(_vm._s(_vm.$t("billing.currentPlans"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "current-plans-wrapper-content" },
          _vm._l(Object.keys(_vm.currentPlanHash), function (key) {
            return _c("PlanItem", {
              key: key,
              attrs: { type: key, currentPlans: _vm.currentPlanHash[key] },
            })
          }),
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }